import { Button, NAME_SOUND_HOVER, TYPE_QUESTIONS, useGameSounds, useMediaQuery, useTranslate, } from "@educaplay/core";
import classes from './TextQuestion.module.scss'
import { useEffect, useState } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { AnimatePresence, motion } from 'framer-motion'
import { TEST_SOUNDS } from "../../../utils/constants";

import InputWithButtons from "../../InputWithButtons";
import clsx from "clsx";
import { NextSubmitButton } from "@educaplay/core/components";

import ButtonNext from "../../ButtonNext";
import ButtonSkip from "../../ButtonSkip";
import ButtonSend from "../../ButtonSend";

import { Check } from "@educaplay/core/Icons/Check";
import { SCREENS } from "@educaplay/store/constants";



export const TextQuestion = (props) => {
    const { question, onAnswer, passFinalQuestion } = props;
    const [inputValue, setInputValue] = useState(question.answer?.answer ?? '');
    const [showInputTop, setShowInputTop] = useState(false);
    const isExamMode = useSelector(state => state.game.examMode);
    const t = useTranslate();
    const gameSound = useGameSounds();
    const inputRef = useRef();
    const inputTopRef = useRef();
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const isInputEmpty = inputValue === '';
    const isAnimating = useSelector(state => state.game.isAnimating);
    const finishEntryAnimation = useSelector(state => state.game.isCompleteEntryAnimation);
    const [hasAnswered, setHasAnswered] = useState(false);
    const liveActived = useSelector(state => state.game.liveActived);
    const currentIndex = useSelector(state => state.game.currentIndex); 
    const screen = useSelector(state => state.game.view); 

    const inputHandler = (event) => {
        setInputValue(event.target.value);

        if (isExamMode) {
            const answer = {
                type: TYPE_QUESTIONS.Text,
                answer: event.target.value.trim()
            }
            onAnswer(answer);
        }
    }
    
    useEffect(() => {
        if (!isInputEmpty && !isExamMode) gameSound.play(TEST_SOUNDS.SHOW_BUTTON);
    }, [isInputEmpty, gameSound, isExamMode]);

    //SONIDOS DE ESCCRIBIR Y BORRAR
    const soundInputHandler = () => {
        if (event.key === 'Backspace' && !isTouchDevice && !isInputEmpty) {
            gameSound.play(TEST_SOUNDS.DELETE);
        }

        if (event.key !== 'Backspace' && event.key !== 'Shift' && !isTouchDevice) {
            gameSound.play(TEST_SOUNDS.WRITE);
        }
    }

    const handleHover = () => {
        gameSound.play(NAME_SOUND_HOVER);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isAnimating || !finishEntryAnimation || hasAnswered || screen === SCREENS.SCORE_SCREEN) return;

        setHasAnswered(true);
        gameSound.play(TEST_SOUNDS.SUBMIT);

        const answer = {
            type: TYPE_QUESTIONS.Text,
            answer: inputValue.trim()
        }
        onAnswer(answer, {
            showFeedback: !(question.checkAnswer(answer) && !liveActived),
            questionIndexAnswer: currentIndex
        });
    }

    const inputTopHandler = () => {
        if (isTouchDevice) {

            setShowInputTop(true);
            const timeOutFocus = setTimeout(() => {
                inputTopRef.current?.focus();
                clearTimeout(timeOutFocus);
            }, 0);
        }
    }

    useEffect(() => {
        const timeOutFocus = setTimeout(() => {
            if (isInputEmpty) inputRef.current?.focus();
            clearTimeout(timeOutFocus);
        }, 500)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <AnimatePresence>
            <motion.form
                key={`question_${question.id}`}
                className={classes.form}
                onSubmit={handleSubmit}
                initial={{ y: "100%" }}
                animate={{ y: "0%" }}
                transition={{ delay: "0.8" }}
                exit={{ opacity: 0 }}
            >
                <div className={classes.inputWrapper} >
                    <input
                        type="text"
                        className={clsx(classes.input, (isTouchDevice && showInputTop) && classes.dontShow)}
                        ref={inputRef}
                        onChange={inputHandler}
                        value={inputValue}
                        onKeyDown={soundInputHandler}
                        onFocus={inputTopHandler}
                        autoFocus
                    />
                </div>
                <div>
                    <InputWithButtons
                        ref={inputTopRef}
                        className={((isTouchDevice && !showInputTop) || !isTouchDevice) && classes.dontShow}
                        show={setShowInputTop}
                        onChange={inputHandler}
                        value={inputValue}>
                        {!isExamMode && !isInputEmpty && (
                            <NextSubmitButton onClick={handleSubmit} showSubmit className={classes.buttonPass} />
                        )}
                        {isExamMode && (
                            <>
                                <ButtonNext handleHover={handleHover} type={(!passFinalQuestion) ? "submit" : "button"} className={classes.specialButtonNext} passFinalQuestion={passFinalQuestion} />
                                {passFinalQuestion && (
                                    <>
                                        <ButtonSkip handleHover={handleHover} className={classes.btnSkip} passFinalQuestion={passFinalQuestion} />
                                        <ButtonSend handleHover={handleHover} className={classes.btnSend} type={(!passFinalQuestion) ? "button" : "submit"} />
                                    </>
                                )}
                            </>
                        )}
                    </InputWithButtons>


                    {!isInputEmpty && !isExamMode && isTouchDevice && (
                        <div className={clsx(classes.buttonContainer, (isTouchDevice && showInputTop) && classes.dontShow)}>


                            <NextSubmitButton showSubmit handleHover={handleHover} />

                        </div>
                    )}

                    {!isInputEmpty && !isExamMode && !isTouchDevice && (
                        <div className={classes.buttonContainer}>
                            <Button type={"submit"}
                                onMouseEnter={handleHover}
                                icon={<Check />}
                                className={classes.sendButtonDesktop}>
                                {t('common.settings.accept')}
                            </Button>

                        </div>
                    )}

                </div>
            </motion.form>
        </AnimatePresence>
    )
}